import request from '@/utils/request'

// =============== 采样任务 ===============

/**
 * @describe 分页查看采样任务
 * @param areaCodeCity
 * @param areaCodeDistrict
 * @param areaCodeSubdistrict
 * @param villageCode
 * @param checkType 检测类型 /dic/getCheckTypeList.do
 * @param state 状态 /dic/getSamplingTaskStateList.do
 * @param entName 被检单位名称
 * @param checkOrgName 检测机构名称
 * @param person 人员
 * @param taskCode 任务编号
 * @param kssj
 * @param jssj
 * @param pageNum 1
 * @param pageSize 20
 */
export function pageSamplingTask(query) {
  return request({
    url: 'sampling/pageSamplingTask.do',
    method: 'GET',
    params: query,
  })
}

/**
 * @describe 保存采样任务
 * @param checkType 检测类型 * 1-企业自检 2-机构检测 3-第三方检测
 * @param taskFromId 任务来源
 * @param taskClassifyId 任务类型
 * @param entId 企业id
 * @param regId 检测机构
 * @param checkOrgName 检测机构名称
 * @param lat 纬度
 * @param lng 经度
 * @param gpsAddr gps地址
 * @param image1 采样现场照片1
 * @param image2 采样现场照片2
 * @param image3 采样现场照片3
 * @param persons 检测人员 - 多人使用逗号分隔
 * @param workerIds 采样人员 - 多人使用逗号分隔
 * @param details 采样明细 []
 * {
 *  samplingTaskDetailId 采样任务详情表id，修改时必传
 *  sampleNo 样品编号，修改时必传
 *  entProductId 企业产品Id
 *  checkWayId 检测方式Id
 *  checkWayName 检测方式
 *  checkItemId 检测项目Id
 *  checkItemName 检测项目 *
 *  sampleCardinal 样品基数
 *  sampleSource 样品来源
 *  image1 产品照片1
 *  image2 产品照片2
 *  image3 产品照片3
 * }
 */
export function saveSamplingTask(query) {
  return request({
    url: 'sampling/saveSamplingTask.do',
    method: 'POST',
    data: query,
    headers: {
      'Content-Type': 'application/json; charset=utf-8'
    }
  })
}

/**
 * @describe 编辑采样任务
 * @param samplingTaskId 采样任务id
 * @param 同上
 */
export function editSamplingTask(query) {
  return request({
    url: 'sampling/editSamplingTask.do',
    method: 'POST',
    data: query,
    headers: {
      'Content-Type': 'application/json; charset=utf-8'
    }
  })
}

/**
 * @describe 删除一个采样任务
 * @param samplingTaskId 采样任务id
 */
export function delOneSamplingTask(query) {
  return request({
    url: 'sampling/delOneSamplingTask.do',
    method: 'POST',
    data: query,
  })
}

/**
 * @describe 获取一个采样任务
 * @param samplingTaskId 采样任务id
 */
export function getOneSamplingTask(query) {
  return request({
    url: 'sampling/getOneSamplingTask.do',
    method: 'GET',
    params: query,
  })
}

/**
 * @describe 上传一个采样任务
 * @param samplingTaskId 采样任务id
 */
export function confirmOneSamplingTask(query) {
  return request({
    url: 'sampling/confirmOneSamplingTask.do',
    method: 'POST',
    data: query,
  })
}

// -------------------- 采样任务明细 ----------------------
/**
 * @describe 删除一个采样任务明细
 * @param samplingTaskDetailId 采样任务明细id
 */
export function delOneSamplingTaskDetail(query) {
  return request({
    url: 'sampling/delOneSamplingTaskDetail.do',
    method: 'POST',
    data: query,
  })
}

/**
 * @describe 分页查看采样任务详情列表
 * @param areaCodeCity
 * @param areaCodeDistrict
 * @param areaCodeSubdistrict
 * @param villageCode
 * @param checkType 检测类型 /dic/getCheckTypeList.do
 * @param state 状态 /dic/getSamplingTaskStateList.do
 * @param entName 被检单位名称
 * @param checkOrgName 检测机构名称
 * @param result 检测结果 1-合格 0-不合格
 * @param sampleNo 样品编号
 * @param productName 产品名称
 * @param kssj
 * @param jssj
 * @param pageNum 1
 * @param pageSize 20
 */
export function pageSamplingTaskDetailVo(query) {
  return request({
    url: 'sampling/pageSamplingTaskDetailVo.do',
    method: 'GET',
    params: query,
  })
}

